import { useSelector } from "react-redux";

export default function useCurrentLocation() {
  const locale = useSelector((state) => state.changeLang.change);
  const search = window.location.search;
  const entryLocation = window.location.pathname.includes("/entry/");
  const localePath = locale !== "en" ? `/${locale}` : "";
  const entryLocationEdit = window.location.search.includes(`back=${localePath}/entry`);
  const urlParams = new URLSearchParams(window.location.search);
  let pageNumber = urlParams.get('page');


  if (entryLocationEdit) {
    const backParam = urlParams.get('back');
    if (backParam) {
      const decodedBackParam = decodeURIComponent(backParam);
      const backParams = new URLSearchParams(decodedBackParam.split('?')[1]);
      pageNumber = backParams.get('page');
    }
  }

  const queryParams = new URLSearchParams(search);
  const isDownloadParam = queryParams.has("download");
  const adminEntryLocation = `${window.location.origin}${
    locale === "en" ? "" : `/${locale}`
  }/entry/`;
  const isTemplateParam = queryParams.has("template");
  const isTemplateService =
    window.location.pathname.includes("/template-service");
    const isGenerator = window.location.pathname.includes("/qr-code-generator");
  const isApiDocLocation = window.location.pathname.includes("/api/doc");
  const urlParam = urlParams.get("url");
  const mepageViewValue = urlParams.get("mepageview");
  const containerValue = urlParams.get("container");

  return {
    pageNumber,
    entryLocationEdit,
    entryLocation,
    isDownloadParam,
    adminEntryLocation,
    isTemplateParam,
    isTemplateService,
    isGenerator,
    isApiDocLocation,
    urlParam,
    mepageViewValue,
    containerValue,
  };
}
